// Note: This mixin is used to communicate between components
export default {
  data() {
    return {
      drawerVisible: {},
      popoverVisible: {}
    }
  },
  methods: {
    // 初始化抽屉
    initDrawerContoller() {
      this.$eventBus.$on("control-drawer", msg => {
        // 根据msg.sourceId找到对应的通栏
        const index = this.pageLayoutList.findIndex(pageLayout => pageLayout.options.source_id === msg.sourceId)
        if(index === -1){
          return
        }
        if (msg.openDrawer) {
          // 根据index激活对应的通栏
          this.activeIndex = index
          this.$store.commit("states/changeActiveID", { container_id: this.id, pageLayoutId: this.activeIndex })
          this.$store.commit("states/changeElementType", "cxPageLayout")
        } else {
          // 关闭通栏，激活按钮
          let param = {
            container_id: 0,
            rect_id: msg.sourceId
          }
          if (msg.sourceId === "notice_drawer") {
            this.$changePageAttribute({ option_name: "showNoticeLayout", option_val: false })
          }
          // this.$store.commit("states/changeActiveID", param)
          // this.$store.commit("states/changeElementType", "cxButton")
        }
        // 根据msg.openDrawer控制抽屉的显示
        this.$set(this.drawerVisible, `drawer-${msg.sourceId}`, msg.openDrawer)
      })
      this.$eventBus.$on("control-popover", msg => {
        this.$set(this.popoverVisible, `popover-${msg.sourceId}`, msg.openPopover)
        const pageLayout = this.pageLayoutList.find(pageLayout => pageLayout.options.source_id === msg.sourceId)
        this.$nextTick(() => {
          if(msg.openPopover) {
            this.$store.commit("states/changeShowRightToolbarStatus", true)
          }
          this.$store.commit("states/changeActiveID", pageLayout.options.sourceIds)
          this.$store.commit("states/changeElementType", "cxButton")
        })
      })
    }
  }
}
